<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const tabs = [
  {
    name: 'Accueil',
    icon: 'home.svg',
    id: 'home'
  },
  {
    name: 'Services',
    icon: 'services.svg',
    id: 'services'
  },
  // {
  //   name: 'Historique',
  //   icon: 'history.svg',
  //   id: 'history'
  // },
  {
    name: 'Pronostics',
    icon: 'pronostics.svg',
    id: 'pronostics'
  },
  {
    name: 'Profile',
    icon: 'user.svg',
    id: 'profile'
  }
];

const activeTab = computed(() => {
  return tabs.find(tab => route.name === tab.id)?.id || '';
});
</script>

<template>
  <div class="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 safe-area-bottom ">
    <div class="py-1"></div>

    <div class="flex justify-around items-center h-16 px-2">
      <router-link
        v-for="tab in tabs"
        :key="tab.id"
        :to="`/${tab.id}`"
        class="flex flex-col items-center justify-center gap-1 min-w-0 flex-1 py-2 relative group"
        :class="{ 'text-primary': activeTab === tab.id, 'text-gray-400': activeTab !== tab.id }"
      >
        <!-- active indicator -->
        <!-- <div
          v-if="activeTab === tab.id"
          class="absolute -top-[1px] left-1/2 -translate-x-1/2 w-8 h-0.5 bg-primary rounded-full"
        ></div> -->

        <!-- icon -->
        <div class="relative w-6 h-6">
          <ColorImg
            :src="`/images/navs/${tab.icon}`"
            :alt="tab.name"
            class="w-full h-full transition-transform duration-300 bg-current"
            :class="{ 'scale-110': activeTab === tab.id }"
          />
        </div>
        <div class=""></div>

        <!-- label -->
        <span
          class="text-xs font-medium transition-all duration-300 opacity-100"
          :class="{
            'font-semibold': activeTab === tab.id,
            'opacity-100': activeTab !== tab.id
          }"
        >
          {{ tab.name }}
        </span>
      </router-link>
    </div>
    <div class="py-2"></div>
    <div class="mobile-bottom-padding"></div>
  </div>
</template>

<style scoped>
.text-primary {
  color: #1686B4;
}
</style>
